// eslint-disable-next-line import/no-extraneous-dependencies
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

function NoMatch() {
  useEffect(() => {
    const styleTags = document.querySelectorAll('style');
    styleTags.forEach((tag) => { return tag.parentNode.removeChild(tag); });
  }, []);

  return (
    <div>
      <Helmet>
        <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
        <title>Error</title>
      </Helmet>
      <div>
        <center>
          <h1>Oops!</h1>
        </center>
        <center>
          <h1>We&apos;re sorry, but something went wrong.</h1>
        </center>
        <hr />
        <center>
          <a
            href="https://insignary.atlassian.net/servicedesk"
            target="_blank"
            rel="noreferrer noopener"
          >
            Service Desk
          </a>
        </center>
      </div>
    </div>
  );
}
export default NoMatch;
